import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.organization.DOC}
  query Organizations(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $entityId: ID!
    $filter: OrganizationsFilterInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                organizations(entityId: $entityId, filter: $filter) {
                  ...FragmentOrganization
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.OrganizationsQuery,
    ents.extra.space.Organization[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'organizations',
                graphql.transformers.OUT.list(
                  fragments.organization.TRANSFORMER,
                  {
                    onNullish: 'remove',
                  },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.OrganizationsQuery,
  ents.extra.space.Organization[],
  graphql.schema.OrganizationsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
